import { getUrlParameter, toQueryString, updatePath } from 'helpers/Url'
import PropTypes from 'prop-types'
import { Component } from 'react'

export class FilterCheckbox extends Component {
  filterString = () => {
    const { name } = this.props

    let values = this.filterValues()

    values[name] = this.checkbox.checked ? 'true' : ''

    return toQueryString(values)
  }

  filterValues = () => {
    let search = window.location.search

    return {
      duration: getUrlParameter(search, 'duration') || '',
      'interests[]': getUrlParameter(search, 'interests[]') || '',
      'software[]': getUrlParameter(search, 'software[]') || '',
      'hardware[]': getUrlParameter(search, 'hardware[]') || '',
      'difficulty_level[]': getUrlParameter(search, 'difficulty_level[]') || '',
      'pdf[]': getUrlParameter(search, 'pdf[]') || '',
    }
  }

  changeHandler = () => {
    const { navigate, locale } = this.props
    let filterUrl = this.filterString()
    updatePath(navigate, locale, '/projects', filterUrl)
  }

  render() {
    const { className, label, name } = this.props

    return (
      <label className={className} htmlFor={name}>
        <input
          type="checkbox"
          aria-label={label}
          name={name}
          id={name}
          onChange={this.changeHandler}
          ref={(checkbox) => (this.checkbox = checkbox)}
          checked={getUrlParameter(window.location.search, name)}
        />
        <span className="checkmark"></span>
        <span className="c-filter__checkbox-label">{label}</span>
      </label>
    )
  }
}

FilterCheckbox.propTypes = {
  className: PropTypes.string,
  navigate: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
}

export default FilterCheckbox
